import { render, staticRenderFns } from "./ViewMyCourse.vue?vue&type=template&id=6986d1e4&scoped=true&"
import script from "./ViewMyCourse.vue?vue&type=script&lang=js&"
export * from "./ViewMyCourse.vue?vue&type=script&lang=js&"
import style0 from "./ViewMyCourse.vue?vue&type=style&index=0&id=6986d1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6986d1e4",
  null
  
)

export default component.exports